import React from 'react';

const NotFound = () => {
    return(
        <div>
            <p>404 ERROR</p>
        </div>
    )
}

export default NotFound;